// extracted by mini-css-extract-plugin
export default {"container":"contactCard_container__px4Jk"};